/* ============================================================
   TDHQ wishlist - tdhq-wishlist.js

   Save products for later. Both competitors checked (MyCarCleaning and Slim's
   Detailing) have this on every product; TDHQ had none.

   WHY NOT THE THEME'S EXISTING ONE: the Ecomus base ships a wishlist
   (`<hdt-wishlist>`, `settings.wishlist_mode`) but it is dead here — the mode is
   set to "0" and `assets/custom.js`, which defines the custom element, is never
   loaded by the layout. It is the third dead Ecomus subsystem in this theme
   after the cart drawer and the mobile toolbar. Reviving it would also render
   Ecomus card markup rather than the theme's own.

   STORAGE is localStorage, so it is per-device and needs no account and no app.
   The page says so in plain words rather than implying the list follows the
   shopper around — a saved list that silently vanishes on another device is
   worse than one that told you where it lived.

   RENDERING reuses the server. The wishlist page fetches
   /products/<handle>?view=card and injects the response, so a saved product
   uses the SAME card snippet as the collections and the homepage. Building card
   markup again here is how two card designs drift apart, which this theme has
   already suffered once.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'tdhq:wishlist:v1';

  function read() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(raw) ? raw.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
  }

  function has(handle) { return read().indexOf(handle) !== -1; }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) { list.unshift(handle); } else { list.splice(i, 1); }
    write(list);
    return i === -1;
  }

  /* Reflect saved state on every button for a handle — a product can appear in
     more than one row on the same page (recently viewed and a product row, say)
     and both hearts must agree. */
  function paint(scope) {
    var list = read();
    var buttons = (scope || document).querySelectorAll('[data-tdhq-wish]');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      var on = list.indexOf(b.getAttribute('data-handle')) !== -1;
      /* only what changed: a same-value write still invalidates the element's style */
      var pressed = on ? 'true' : 'false';
      if (b.getAttribute('aria-pressed') !== pressed) b.setAttribute('aria-pressed', pressed);
      if (b.classList.contains('is-saved') !== on) b.classList.toggle('is-saved', on);
      var label = b.getAttribute(on ? 'data-label-saved' : 'data-label-save');
      if (label && b.getAttribute('aria-label') !== label) b.setAttribute('aria-label', label);
      /* The product-page button also carries a VISIBLE label. Card hearts have
         no text node, so this is skipped there rather than special-cased. */
      var text = b.querySelector('[data-tdhq-wish-text]');
      if (text) text.textContent = on ? 'Saved' : 'Save for later';
    }
    /* The route to the saved items is worth showing once there is something to
       look at. It follows the LIST, not a button: it used to be set inside the
       loop above, so the last heart on the page - a related product's, usually
       unsaved - decided it, and saving this product left the link hidden. */
    var links = document.querySelectorAll('[data-tdhq-wish-link]');
    for (var k = 0; k < links.length; k++) { links[k].hidden = list.length === 0; }
    var counts = document.querySelectorAll('[data-tdhq-wish-count]');
    for (var c = 0; c < counts.length; c++) {
      counts[c].textContent = list.length;
      counts[c].hidden = list.length === 0;
    }
  }

  /* Buttons that arrive after load (quick view) are painted by their owner. */
  window.tdhqWishPaint = paint;

  function announce(message) {
    var live = document.getElementById('tdhq-quickadd-live');
    if (!live) return;
    live.textContent = '';
    window.requestAnimationFrame(function () { live.textContent = message; });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-tdhq-wish]') : null;
    if (!btn) return;
    event.preventDefault();
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    var added = toggle(handle);
    paint(document);
    announce((btn.getAttribute('data-title') || 'Item') + (added ? ' saved for later' : ' removed from saved items'));
    if (added) { bump(); }

    /* In a saved list - the page or the panel - removing an item must remove
       its card too, otherwise the heart goes empty and the product stays. */
    var grid = btn.closest('[data-tdhq-wishlist-grid], [data-tdhq-saved-list]');
    if (grid && !added) {
      var card = btn.closest('.tdhq-pcard');
      if (card) { leave(card, grid); }
    }

    /* Saving from the recently viewed row of an empty panel: the panel has a
       saved list to show now, so it redraws as one (and the row steps aside). */
    if (added && btn.closest('[data-tdhq-saved-recent]')) {
      var dlg = btn.closest('[data-tdhq-saved]');
      var savedGrid = dlg && dlg.querySelector('[data-tdhq-saved-list]');
      if (savedGrid) { renderList(savedGrid); }
    }
  });

  /* The count badges pop once when something is saved, so the shopper sees
     WHERE it went - the heart in the header, or the Saved tab on a phone. */
  function bump() {
    var counts = document.querySelectorAll('[data-tdhq-wish-count]');
    for (var i = 0; i < counts.length; i++) {
      var el = counts[i];
      el.classList.remove('is-bump');
      void el.offsetWidth; /* restart the animation if it is already running */
      el.classList.add('is-bump');
    }
  }

  /* A removed card fades and shrinks out, and the cards that stay glide into its place instead of jumping
     (21 Oct): TdhqMotion.leave, then TdhqMotion.flip, the site's one motion system. */
  function leave(card, grid) {
    var M = window.TdhqMotion;
    var done = function () {
      var drop = function () { if (card.parentNode) { card.parentNode.removeChild(card); } };
      if (M) { M.flip(grid, '.tdhq-pcard', drop); } else { drop(); }
      if (!grid.querySelector('.tdhq-pcard')) { renderList(grid); }
    };
    if (M) { M.leave(card, done); } else { done(); }
  }

  /* ---- the wishlist page ---- */

  /* The empty state that belongs to a grid: the page's sits beside its grid,
     the panel's inside the panel body. */
  function emptyFor(grid) {
    if (grid.hasAttribute('data-tdhq-saved-list')) {
      var panel = grid.closest('[data-tdhq-saved]');
      return panel ? panel.querySelector('[data-tdhq-saved-empty]') : null;
    }
    return document.querySelector('[data-tdhq-wishlist-empty]');
  }

  function renderPage() {
    var grid = document.querySelector('[data-tdhq-wishlist-grid]');
    if (grid) { renderList(grid); }
  }

  function renderList(grid) {
    var empty = emptyFor(grid);
    var list = read();
    var requestId = (grid._tdhqWishRequest || 0) + 1;
    grid._tdhqWishRequest = requestId;
    grid.setAttribute('data-rendered', list.join('|'));
    /* the panel's grid, not the page's: only the panel has a recently viewed row */
    var dlg = grid.hasAttribute('data-tdhq-saved-list') ? grid.closest('[data-tdhq-saved]') : null;

    if (!list.length) {
      grid.innerHTML = '';
      grid.hidden = true;
      if (empty) { empty.hidden = false; if (window.TdhqMotion) { window.TdhqMotion.show(empty); } }
      if (dlg) { renderRecent(dlg); }
      return;
    }
    grid.hidden = false;
    if (empty) empty.hidden = true;
    if (dlg) { hideRecent(dlg); }

    /* Placeholders while the cards load, one per saved item up to a screenful,
       so the panel opens at its working size instead of growing as they land. */
    grid.setAttribute('aria-busy', 'true');
    grid.innerHTML = '';
    for (var g = 0; g < Math.min(list.length, 6); g++) {
      var ghost = document.createElement('div');
      ghost.className = 'tdhq-saved-ghost';
      ghost.setAttribute('aria-hidden', 'true');
      grid.appendChild(ghost);
    }

    /* Fetch every saved product's card in parallel, then insert in SAVED order.
       Promise order is not response order, so the results are placed by index
       rather than appended as they arrive. */
    Promise.all(list.map(fetchCard)).then(function (cards) {
      if (grid._tdhqWishRequest !== requestId) { return; }
      if (read().join('|') !== list.join('|')) { renderList(grid); return; }
      var failed = false;
      var frag = document.createDocumentFragment();
      var missing = [];
      cards.forEach(function (html, i) {
        if (html === 'GONE') { missing.push(list[i]); return; }
        if (!html) { failed = true; return; }
        /* innerHTML is deliberate and the input is not user content: this string
           is the response from OUR OWN storefront rendering OUR OWN card
           template, same-origin, for a handle that was url-encoded before the
           request. The stored value is only ever a product handle — a shopper
           cannot put markup into it. Only a confirmed 404 removes a saved handle;
           a temporary failure retains it for another attempt. This is the same mechanism Shopify's own
           Section Rendering pattern uses. */
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var card = holder.querySelector('.tdhq-pcard');
        if (!card) { failed = true; return; }
        /* the grid carries data-dtc-appear, so the cards stagger in by themselves */
        if (card) frag.appendChild(card);
      });
      grid.innerHTML = '';
      grid.appendChild(frag);
      grid.removeAttribute('aria-busy');

      /* A confirmed 404 means the product is no longer publicly available.
         Network failures and 5xx responses must never erase saved products. */
      if (missing.length) {
        write(read().filter(function (h) { return missing.indexOf(h) === -1; }));
      }
      paint(document);
      if (failed) {
        grid.removeAttribute('data-rendered'); /* Reopening the panel also retries. */
        var notice = document.createElement('div');
        notice.style.gridColumn = '1 / -1';
        var message = document.createElement('p');
        message.setAttribute('role', 'status');
        message.textContent = 'Some saved items could not load. Please try again.';
        var retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'dtc-btn';
        retry.textContent = 'Try again';
        retry.addEventListener('click', function () { renderList(grid); });
        notice.appendChild(message); notice.appendChild(retry);
        grid.appendChild(notice);
      }
      if (!failed && !grid.querySelector('.tdhq-pcard')) {
        grid.hidden = true;
        if (empty) { empty.hidden = false; if (window.TdhqMotion) { window.TdhqMotion.show(empty); } }
        if (dlg) { renderRecent(dlg); }
      }
    });
  }

  /* One product's card, GONE for HTTP 404, or null for a temporary failure. Shared by the
     saved list and the recently viewed row, so both render the same card. */
  function fetchCard(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?view=card', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : (r.status === 404 ? 'GONE' : null); })
      .catch(function () { return null; });
  }

  /* ---- the empty panel: recently viewed, or the merchant's suggestions ----

     An empty Saved panel was a heart, one sentence and a button at the top of
     a full-height sheet. Measured at 1440 the button ended at y=360 and the
     next thing below it was the 'Saved on this device.' note at y=855: 495px
     of white (audit home-24). Under the message there is now a row of cards:
     - the shopper's own recently viewed products, which dtc-core.js already
       records on every product page (dtc_recent_v1), in stock first and sold
       out last like every product row on the site;
     - with no history (a first visit), the collection picked in the header's
       "Saved panel suggestions" setting, in the merchant's own order with
       in-stock products first, under the heading set there.
     Products already saved and the product on screen are left out. The row is
     rendered hidden by the header section (so dtc-core.js has armed its drag
     rail at load) and is moved into the panel body here. With neither source
     there is no row, and tdhq-fix-chrome.css centres the message instead. */
  var RECENT_KEY = 'dtc_recent_v1';
  var RECENT_MAX = 6;

  function handleOf(url) {
    var h = typeof url === 'string' ? url.split('/products/')[1] : '';
    return h ? h.split('?')[0].split('#')[0] : '';
  }

  /* saved products and the one on screen never appear in the row */
  function rowSkip() {
    var skip = read();
    var cur = document.querySelector('[data-dtc-current-product]');
    if (cur) {
      try { skip.push(handleOf(JSON.parse(cur.textContent).url)); } catch (e) { /* not a product page */ }
    }
    return skip;
  }

  function recentHandles(skip) {
    var raw;
    try { raw = JSON.parse(localStorage.getItem(RECENT_KEY)); } catch (e) { raw = null; }
    if (!Array.isArray(raw)) { return []; }
    var out = [];
    raw.forEach(function (p) {
      var h = handleOf(p && p.url);
      if (h && skip.indexOf(h) === -1 && out.indexOf(h) === -1) { out.push(h); }
    });
    return out;
  }

  /* The header prints the suggestion handles, already in-stock first. A blank
     heading means no collection is set, and a row is never shown unlabelled. */
  function suggestedHandles(box, skip) {
    var el = box.querySelector('[data-tdhq-saved-suggest]');
    var data = null;
    try { data = el ? JSON.parse(el.textContent) : null; } catch (e) { data = null; }
    if (!data || typeof data.heading !== 'string' || !data.heading || !Array.isArray(data.handles)) { return null; }
    var out = data.handles.filter(function (h) { return typeof h === 'string' && h && skip.indexOf(h) === -1; });
    return out.length ? { heading: data.heading, handles: out } : null;
  }

  function hideRecent(dlg) {
    var box = dlg.querySelector('[data-tdhq-saved-recent]');
    if (box) { box.hidden = true; }
  }

  function renderRecent(dlg) {
    var body = dlg.querySelector('.tdhq-saved__body');
    var box = document.querySelector('[data-tdhq-saved-recent]');
    if (!body || !box) { return; }
    if (box.parentNode !== body) { body.appendChild(box); }

    var skip = rowSkip();
    var heading = 'Recently viewed';
    var handles = recentHandles(skip);
    /* History is sorted here, so all of it is fetched (at most eight): a sold-out
       product has to be known as one before it can go behind the rest. The
       suggestions arrive sorted, so only as many as the row shows, plus two
       spare for a product that no longer resolves. */
    var fetchList = handles;
    if (!handles.length) {
      var sug = suggestedHandles(box, skip);
      if (!sug) { box.hidden = true; return; }
      heading = sug.heading;
      handles = sug.handles;
      fetchList = handles.slice(0, RECENT_MAX + 2);
    }
    var key = heading + '|' + handles.join('|');
    /* the same row as last time: show what was drawn (or nothing, if none of it
       resolved) rather than fetching it again */
    if (box.getAttribute('data-rendered') === key) {
      box.hidden = box.hasAttribute('data-none');
      return;
    }
    var title = box.querySelector('.tdhq-saved__recenttitle');
    var grid = box.querySelector('[data-tdhq-saved-recent-list]');
    if (title) { title.textContent = heading; }
    box.setAttribute('data-rendered', key);
    box.removeAttribute('data-none');
    box.hidden = false;

    /* placeholders at the row's final size while the cards load */
    grid.setAttribute('aria-busy', 'true');
    grid.innerHTML = '';
    for (var g = 0; g < Math.min(fetchList.length, RECENT_MAX); g++) {
      var ghost = document.createElement('div');
      ghost.className = 'tdhq-saved-ghost';
      ghost.setAttribute('aria-hidden', 'true');
      grid.appendChild(ghost);
    }

    /* innerHTML here is the same same-origin card template as in renderList
       above, for a handle that was url-encoded before the request. */
    Promise.all(fetchList.map(fetchCard)).then(function (cards) {
      if (box.getAttribute('data-rendered') !== key) { return; } /* a newer draw took over */
      var inStock = [];
      var soldOut = [];
      cards.forEach(function (html) {
        if (!html || html === 'GONE') { return; }
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var card = holder.firstElementChild;
        if (card) { (card.classList.contains('tdhq-pcard--out') ? soldOut : inStock).push(card); }
      });
      var show = inStock.concat(soldOut).slice(0, RECENT_MAX);
      grid.innerHTML = '';
      grid.scrollLeft = 0;
      show.forEach(function (card) { grid.appendChild(card); });
      grid.removeAttribute('aria-busy');
      if (!show.length) {
        box.setAttribute('data-none', '');
        box.hidden = true;
      }
      paint(dlg);
    });
  }

  /* ---- the saved panel ---- */

  /* A PANEL, NOT A MODAL (chrome-07, 2026-09-23). On a phone it rises above
     the tab bar like the menu and the basket, and the tab bar stays live;
     showModal put the whole page, tab bar included, behind it. So the panel
     brings what showModal gave: a scrim, Escape, focus kept inside and handed
     back to the opener. It moves to <body> on first use: the header it is
     rendered in is a stacking context that would hold it under the tab bar. */
  var savedFrom = null;
  function panel() { return document.querySelector('[data-tdhq-saved]'); }
  function scrim() { return document.querySelector('[data-tdhq-saved-scrim]'); }
  function markOpeners(on) {
    document.querySelectorAll('button[data-tdhq-saved-open]').forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
  }
  function closePanel() { var dlg = panel(); if (dlg && dlg.open) { dlg.close(); } }
  window.tdhqSavedClose = closePanel;

  function openPanel() {
    var dlg = panel();
    if (!dlg || typeof dlg.show !== 'function') { return false; }
    var grid = dlg.querySelector('[data-tdhq-saved-list]');
    /* re-fetch only when the list changed since the panel last drew it; an
       empty list still re-checks its recently viewed row, which no-ops when the
       history is the one it last drew */
    if (grid && grid.getAttribute('data-rendered') !== read().join('|')) {
      renderList(grid);
    } else if (grid && !read().length) {
      renderRecent(dlg);
    }
    if (!dlg.open) {
      var sc = scrim();
      /* U.42: into the header section (not <body>), so the phone tab bar and its basket count stay in front of
         the sheet; the section is lifted while it is open (tdhq-header.css). */
      var host = document.querySelector('.tdhq-header-section') || document.body;
      if (dlg.parentNode !== host) {
        if (sc) { host.appendChild(sc); }
        host.appendChild(dlg);
      }
      if (!dlg.__tdhqBound) {
        dlg.__tdhqBound = true;
        dlg.addEventListener('close', function () {
          var s = scrim();
          if (s) { s.hidden = true; }
          document.documentElement.classList.remove('tdhq-saved-open');
          markOpeners(false);
          if (savedFrom && savedFrom.focus && document.contains(savedFrom)) { savedFrom.focus({ preventScroll: true }); }
          savedFrom = null;
        });
      }
      savedFrom = document.activeElement;
      if (sc) { sc.hidden = false; }
      dlg.show();
      document.documentElement.classList.add('tdhq-saved-open');
      markOpeners(true);
      var shut = dlg.querySelector('[data-tdhq-saved-close]');
      if (shut && shut.focus) { shut.focus({ preventScroll: true }); }
    }
    return true;
  }

  /* Escape closes it; Tab and Shift+Tab stay inside it while it is open. */
  document.addEventListener('keydown', function (e) {
    var dlg = panel();
    if (!dlg || !dlg.open) { return; }
    if (e.key === 'Escape') { e.preventDefault(); dlg.close(); return; }
    if (e.key !== 'Tab') { return; }
    var f = [].filter.call(dlg.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'), function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0;
    });
    if (!f.length) { return; }
    if (!dlg.contains(document.activeElement)) { e.preventDefault(); f[0].focus(); return; }
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest) { return; }
    var opener = event.target.closest('[data-tdhq-saved-open]');
    if (opener) {
      /* the tab bar's Saved tab is a toggle, like its Shop tab */
      var open = panel();
      if (open && open.open && opener.closest('[data-tdhq-tabbar]')) { event.preventDefault(); open.close(); return; }
      if (openPanel()) { event.preventDefault(); }
      return;
    }
    var dlg = panel();
    if (!dlg || !dlg.open) { return; }
    /* the close button, or the scrim beside the panel */
    if (event.target.closest('[data-tdhq-saved-close]') || event.target.closest('[data-tdhq-saved-scrim]')) {
      dlg.close();
    }
  });

  function init() {
    paint(document);
    renderPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Storage changes in another tab should be reflected here. */
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) { return; }
    paint(document);
    var dlg = panel();
    if (dlg && dlg.open) { renderList(dlg.querySelector('[data-tdhq-saved-list]')); }
  });

  document.addEventListener('shopify:section:load', function () { paint(document); });
  /* Filters, sort, pages and the sold-out-last rebuild swap the collection's
     cards in without a section:load (that event is theme-editor only), so
     their hearts were drawn unsaved. The collection script announces its swaps. */
  document.addEventListener('tdhq:collection:updated', function () { paint(document); });
})();
